<template>
  <h3 class="datos-cliente">
    <fai icon="user-circle" class="fa-2x align-middle" />
    {{ cliente.nombre }} {{ cliente.numDoc }}
  </h3>
</template>

<script>
export default {
  props: {
    cliente: {
      type: Object,
      required: true
    }
  },

  methods: {
    seleccionarCliente() {
      this.$store.dispatch("getCliente").then(() => {
        this.$router.push({ name: "cliente" });
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
